import { isEmpty } from "lodash";
/**
 * @param {string} key localStorage key
 * @returns existingItem object, or false if nothing was found
 */
const getExistingItemInStorage = key => {
	let existingItem = JSON.parse(localStorage.getItem(key));
	if (existingItem) {
		return existingItem;
	} else {
		return false;
	}
};

/**
 * @description Will add a property to an existing object stored in localStorage. If the object doesn't exist, it'll create it.
 * @param {string} key localStorage key
 * @param {string} property property you want to save in the object
 * @param {any} value any value you want to store to the object property
 * @returns void
 */
export const addPropertyToObject = (key, property, value) => {
	let existingItem = getExistingItemInStorage(key);
	if (!existingItem) {
		existingItem = {};
	}
	existingItem[property] = value;
	localStorage.setItem(key, JSON.stringify(existingItem));
};

/**
 * @description Will remove a property from an object in localStorage.
 * @param {string} key localStorage key
 * @param {string} property property that you want to remove from the object
 * @returns false if there is no existing item in localStorage, otherwise void
 */
export const removePropertyFromObject = (key, property) => {
	let existingItem = getExistingItemInStorage(key);
	if (!existingItem) {
		return false;
	}
	delete existingItem[property];
	localStorage.setItem(key, JSON.stringify(existingItem));
};

/**
 * @description Will append an object of data to an existing object in localStorage. If there is no existing object in localStorage, it will save the data you pass in localStorage.
 * @param {string} key localStorage key
 * @param {object} data data you want to append to object in localStorage
 * @returns void
 */
export const addDataToObject = (key, data) => {
	let existingItem = getExistingItemInStorage(key);
	if (!isEmpty(existingItem)) {
		existingItem = {
			...existingItem,
			...data,
		};
	} else {
		existingItem = { ...data };
	}
	localStorage.setItem(key, JSON.stringify(existingItem));
};

/**
 * @description Replaces an existing object in storage
 * @param {string} key localStorage key
 * @param {object} data data you want to save in localStorage (JSON.stringify(data))
 */
export const replaceObjectInStorage = (key, data) => {
	let existingItem = getExistingItemInStorage(key);
	if (!isEmpty(existingItem)) {
		localStorage.setItem(key, JSON.stringify(data));
	}
};

/**
 * @description Removes whatever you want from localStorage
 * @param {string} key localStorage key you want to delete
 */
export const removeFromStorage = key => {
	localStorage.removeItem(key);
};
